module.exports = __webpack_public_path__ + "static/excutive-compass-image-1-f925297a3baf6c81f20905d560479f44.png";